export default __webpack_public_path__ + "static/media/O-014.21eef203.png";